<template>
  <div class="home_page">
    <!-- Hero 区：左侧主视频 + 右侧竖向推荐栏（图1 B站直播风格），只有首页显示 -->
      <div v-if="activeNav === -1" class="hero_section">
       <!-- Hero 区背景图 -->
        <div class="hero_bg">
          <img src="../../assets/katou.png" class="hero_bg_img" alt="">
        </div>
        <!-- 图1布局：左侧主视频 + 右侧竖向推荐栏 -->
        <div class="hero_inner">
        <!-- 全宽大视频区 -->
        <div class="hero_main">
          <div class="banner_bg_blur" :style="{ backgroundImage: `url(${getBannerVal(activeBanner,'image')})` }"></div>
          <div class="banner_img">
            <video
              v-if="getBannerVal(activeBanner,'anchor_video')"
              ref="mainVideo"
              class="banner-video"
              muted
              playsinline
              @ended="onVideoEnded"
            ></video>
          </div>
          <div class="banner_overlay"></div>
          <div class="banner_info">
            <span class="live_tag">直播中</span>
            <h2 class="banner_title">{{ getBannerVal(activeBanner,'content') }}</h2>
            <div class="anchor_info">
              <img :src="getBannerVal(activeBanner,'touxiang')" class="anchor_avatar" />
              <span class="anchor_name">{{ getBannerVal(activeBanner,'anchor_name') }}</span>
            </div>
            <div class="stats">
              <span class="stat_item"> <img src="../../assets/renshu.png" alt="">{{ getBannerVal(activeBanner,'anchor_number') }} 人正在观看</span>
              <span class="stat_item"> <img src="../../assets/xihuan.png" alt="">{{ getBannerVal(activeBanner,'hot') }} 人喜欢</span>
            </div>
          </div>
          <button class="enter_btn" @click="enterLiveRoom( getBannerVal(activeBanner,'id'), getBannerVal(activeBanner,'anchorid'))">点击进入直播</button>
        </div>

        <!-- 右侧竖向推荐栏 -->
        <div class="hero_rail">
          <div
            v-for="(item, index) in bannerList"
            :key="item.id"
            class="rail_card"
            :class="{ active: activeBannerIndex === index }"
            @click="switchBanner(index)"
          >
            <img :src="getBannerVal(item,'image')" class="rail_img" />
            <div class="rail_mask"></div>
            <div class="rail_text">
              <p class="rail_card_title">{{ getBannerVal(item,'content') }}</p>
              <p class="rail_card_name">{{ getBannerVal(item,'anchor_name') }}</p>
            </div>
          </div>
        </div>
        </div>
      </div>
        
    <!-- 主内容区 -->
    <div class="main_content">

      <!-- 推荐直播 -->
      <section class="section">
        <div class="section_header">
          <h3 class="section_title">{{ activeNav === -1 ? '正在直播' : navItems[activeNav] }}</h3>
        </div>
        <div :class="hasTitleParam ? 'featured_grid' : 'featured_grid_horizontal'">
          <div v-for="item in featuredList" :key="item.id" :class="hasTitleParam ? 'featured_card' : 'featured_card_horizontal'" @click="handleCardClick(item)">
            <div :class="hasTitleParam ? 'card_image_wrap' : 'card_image_wrap_horizontal'">
              <img :class="hasTitleParam ? 'card_image' : 'card_image_horizontal'" :src="getBannerVal(item,'image')" alt="">
              <!-- 遮罩层：待开播时更深 -->
              <div :class="getBannerVal(item,'statuss') == 0 ? 'card_overlay_offline' : (hasTitleParam ? 'card_overlay' : 'card_overlay_horizontal')"></div>
              <!-- 待开播中间显示 -->
              <div v-if="getBannerVal(item,'statuss') == 0 " class="offline_center_text">
                <div class="offline_status">待开播</div>
                <div v-if="getBannerVal(item,'add_time')" class="offline_time">{{ getBannerVal(item,'add_time') }}</div>
              </div>
              <div :class="hasTitleParam ? 'live_badge' : 'live_badge_horizontal'">
                <!-- 只有在选择类型（hasTitleParam=true）时才判断huifang字段 -->
                <template v-if="hasTitleParam">
                  <!-- huifang为0是直播，为1是回放 -->
                  <!-- huifang=0直播：正常显示直播标签+人数 -->
                  <template v-if="getBannerVal(item,'huifang') == 0">
                    <span class="live_badge_text">直播</span>
                    <span class="live_badge_count">
                      <img src="../../assets/renshu.png" alt="">
                      {{ getBannerVal(item,'anchor_number') }}
                    </span>
                  </template>
                  <!-- huifang=1回放：只显示回放二字，灰色背景，隐藏人数 -->
                  <template v-else>
                    <span class="live_badge_text_live">回放</span>
                  </template>
                </template>
                <!-- 首页（hasTitleParam=false）保持原有逻辑 -->
                <template v-else>
                  <span :class="getBannerVal(item,'statuss') == 0 ? 'live_badge_text_offline' : 'live_badge_text'">{{ getBannerVal(item,'statuss') == 0 ? '待开播' : '直播' }}</span>
                  <span v-if="getBannerVal(item,'statuss') == 1" class="live_badge_count">
                    <img src="../../assets/renshu.png" alt="">
                    {{ getBannerVal(item,'anchor_number') }}
                  </span>
                </template>
              </div>
            </div>
            <!-- 卡片主体：介绍 + 信息行 + 浮层（相对定位容器，浮层自动贴图片下方） -->
            <div class="card_body">
              <!-- 卡片介绍文字 -->
              <div class="card_desc">{{ getBannerVal(item,'content') }}</div>
              <!-- 图片下方信息行：头像+主播名 | 👁人数 -->
              <div class="card_info_row">
                <div class="card_info_left">
                  <img :src="getBannerVal(item,'touxiang')" class="card_avatar_sm" />
                  <span class="card_name_sm">{{ getBannerVal(item,'anchor_name') }}</span>
                </div>
                <div class="card_info_right">
                    <i class="el-icon-view"></i>
                  <span class="card_view_num">{{ getBannerVal(item,'anchor_number') || 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 星动活动：只有首页显示 -->
      <section v-if="activeNav === -1" class="section">
        <div class="activity_grid" @click="openAd">
          <img class="activity_image" src="../../assets/4456.webp" alt="">
        </div>
      </section>

      <!-- 直播回放：只有首页显示 -->
      <section v-if="activeNav === -1" class="section">
        <div class="section_header">
          <h3 class="section_title">直播回放</h3>
        </div>
        <div class="category_grid">
          <div v-for="item in categoryList" :key="item.id" class="category_card" @click="huifang(getBannerVal(item,'id'),getBannerVal(item,'anchorid'))">
            <img class="category_image" :src="getBannerVal(item,'hfimage')" alt="">
            <div class="category_overlay"></div>
            <div class="category_live_badge">
              <span class="category_live_text">回放</span>
            </div>
            <div class="category_anchor">
              <img :src="getBannerVal(item,'touxiang')" class="category_avatar" />
              <span class="category_name">{{ getBannerVal(item,'anchor_name') }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Hls from 'hls.js';
export default {
  name: 'HomePage',
  components:{},
  // 分类导航的状态由外层 homeT 管理，通过 props 传入
  props: {
    activeNav: {
      type: Number,
      default: -1
    },
    navItems: {
      type: Array,
      default: () => ['音乐', '乐器', '舞蹈', '颜值', '生活方式']
    },
    navReloadSignal: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeBannerIndex: 0,
      hlsInstance: null,
      bannerList: [],
      currentVideoTime: 0,
      featuredList: [],
      categoryList: [],
      activityList: [
        { id: 1, image: require('../../assets/guizeti.png') },
        { id: 2, image: require('../../assets/jiyi.png') }
      ],
      // 是否有title参数，控制推荐直播布局
      hasTitleParam: false,


    }
  },
  computed: {
    activeBanner() {
      return this.bannerList[this.activeBannerIndex] || {}
    }
  },
  mounted() {
    this.AXIOS_getdata()
    // 监听页面刷新/关闭事件，在离开前保存进度
    // 使用箭头函数确保 this 指向组件实例
    this._beforeUnloadHandler = () => {
      this.handleBeforeUnload()
    }
    window.addEventListener('beforeunload', this._beforeUnloadHandler)
  },
  watch: {
    // 监听外层传入的导航选中项，切换分类时重新拉取数据
    activeNav() {
      this.AXIOS_getdata()
    },
    // 同分类重复点击时 activeNav 不变，监听 signal 递增以强制刷新
    navReloadSignal() {
      this.AXIOS_getdata()
    },
    activeBannerIndex() {
      this.$nextTick(() => {
        this.playActiveVideo()
      })
    }
  },
  methods: {
    // 通用取值：有anchor取子对象，没有取外层（适配three回放anchor=null）
    getBannerVal(item, key){
      if(!item) return ''
      if(item.anchor && item.anchor[key] !== undefined){
        return item.anchor[key]
      }else{
        return item[key] || ''
      }
    },
    goToLogin() {
      this.$router.push('/gr');
    },
    //广告位跳转
    Tiaozhuan(item){
      console.log(item.id);
       axios.post('https://guangxing.xiangyouhulian.cn/api/index/batwo')
       .then( res=>{
        // console.log(res.data.data[0].id,res.data.data[0].anchorid);
        if(item.id==3){
          window.open('https://www.12377.cn/','_blank');
        }else if(item.id==2){
          this.enterLiveRoom(res.data.data[0].id,res.data.data[0].anchorid);
        }else if(item.id==1){
          this.enterLiveRoom(res.data.data[1].id,res.data.data[1].anchorid);
        }
       }).catch(err=>{
        console.log(err)
       })

      },
    //广告图点击 - 新标签页打开外部链接
    openAd(){
      window.open('https://rocom.qq.com/','_blank');
    },
    //未成年人跳转（未登录时-登录时跳转的不一样）
    wcnTc(){
      console.log('wcnTc clicked');
      // 检查用户是否登录
      const isLoggedIn = this.$store.state.LoginStorage && this.$store.state.LoginStorage.id
      console.log('isLoggedIn:', isLoggedIn)
      if (isLoggedIn) {
        // 已登录：跳转到设置页面并自动打开未成年人模式弹窗
        this.$router.push({
          path: '/shezhi',
          query: { openTeenagerModal: 'true' }
        })
      } else {
        // 未登录：通知父组件显示未成年人保护提示弹窗
        console.log('emitting showMinorProtection')
        this.$emit('showMinorProtection')
      }
    },
    //每秒都会执行
    // onVideoTimeUpdate() {
    //   const currentBanner = this.activeBanner;
    //   const anchorid = this.getBannerVal(currentBanner, 'anchorid')
    //   const video = this.$refs.mainVideo
    //   if (!video) return
    //   console.log('@@@@@@@-当前播放视频的id信息:', 'id：',currentBanner.id,'anchorid：',anchorid)
    // },
    // 视频播放完成回调
    onVideoEnded() {
      const currentBanner = this.activeBanner;
      if (!currentBanner?.id) return
      const anchorid = this.getBannerVal(currentBanner, 'anchorid')
      if (!anchorid) return
      // 视频播放完成，调用接口保存1800秒
      axios.post('https://guangxing.xiangyouhulian.cn/api/index/saveAdd10Sec', {
        vid: currentBanner.id,
        pos: anchorid,
        sec: 1800
      }).then(res => {
        console.log('视频播放完成，保存进度成功:', res.data)
      }).catch(err => {
        console.log('视频播放完成，保存进度失败:', err)
      })
    },
    // 处理页面刷新或关闭前的保存逻辑
    handleBeforeUnload() {
      // 页面关闭前使用 sendBeacon 同步保存进度到后端
      const video = this.$refs.mainVideo
      const currentBanner = this.activeBanner
      if (!video || !currentBanner?.id) return
      const anchorid = this.getBannerVal(currentBanner, 'anchorid')
      if (!anchorid) return
      const currentTime = Math.floor(video.currentTime || 0)
      if (currentTime <= 0) return

      const data = JSON.stringify({
        vid: currentBanner.id,
        pos: anchorid,
        sec: currentTime
      })

      // 使用 sendBeacon 确保请求在页面关闭前发送
      const url = 'https://guangxing.xiangyouhulian.cn/api/index/saveAdd10Sec'
      const blob = new Blob([data], { type: 'application/json' })
      navigator.sendBeacon(url, blob)
    },
    enterLiveRoom(id, pos) {
      console.log('进入直播间，id:', id, 'pos:', pos)
      this.saveCurrentVideoProgress()
      this.$router.push(`/zb/${id}/${pos || 1}`);
    },
    // 处理卡片点击 - 根据huifang字段判断跳转
    handleCardClick(item) {
      const id = this.getBannerVal(item, 'id')
      const anchorid = this.getBannerVal(item, 'anchorid')
      const huifang = this.getBannerVal(item, 'huifang')

      // 只有在选择类型页面（hasTitleParam=true）且huifang=1时才跳转到回放页
      if (this.hasTitleParam && huifang == 1) {
        console.log('跳转到回放页面，id:', id, 'anchorid:', anchorid)
        // TODO: 这里先用假路径，后面自己改成真实路径
        this.$router.push(`/hf/${id}/${anchorid}`);
      } else {
        // 其他情况进入直播间
        this.enterLiveRoom(id, anchorid);
      }
    },
    //huifang
    huifang(id,pos) {
      // this.saveCurrentVideoProgress()
      this.$router.push(`/hf/${id}/${pos}`);
    },
    switchBanner(index) {
      // 切换视频前：先保存当前视频的观看进度
      this.saveCurrentVideoProgress()
      // 更新当前视频ID（用于localStorage的key）
      const newBanner = this.bannerList[index] || {}
      this.currentVideoId = this.getBannerVal(newBanner, 'id')
      // 切换active索引，触发watch中的playActiveVideo
      this.activeBannerIndex = index
    },
    saveCurrentVideoProgress() {
      const video = this.$refs.mainVideo
      const currentBanner = this.activeBanner
      if (!video || !currentBanner?.id) return
      const anchorid = this.getBannerVal(currentBanner,'anchorid')
      if(!anchorid) return
      const currentTime = Math.floor(video.currentTime || 0)
      if (currentTime <= 0) return
      // const sendSec = currentTime >= 1800 ? 0 : currentTime
      console.log(currentTime, '秒，保存视频进度')
      // vid传递主播记录的id，pos传递anchorid
      axios.post('https://guangxing.xiangyouhulian.cn/api/index/saveAdd10Sec', {
        vid: currentBanner.id,
        pos: anchorid,
        sec: currentTime
      }).then(res => {
        console.log('保存视频进度成功:', res.data)
        // 保存成功后不刷新数据，避免页面闪烁
      }).catch(err => {
        console.log('保存视频进度失败:', err)
      })
    },
    getVideoProgress(vid, pos) {
      return new Promise((resolve) => {
        axios.get('https://guangxing.xiangyouhulian.cn/api/index/getinfo', {
          params: { vid, pos }
        }).then(res => {
          console.log('获取视频进度:', res.data)
          if (res.data.data) {
            resolve(parseFloat(res.data.data.start_second) || 0)
          } else {
            resolve(0)
          }
        }).catch(err => {
          console.log('获取视频进度失败:', err)
          resolve(0)
        })
      })
    },
    destroyHls() {
      if (this.hlsInstance) {
        this.hlsInstance.destroy()
        this.hlsInstance = null
      }
    },
    initHls(video, videoUrl, startTime = 0) {
      this.destroyHls()
      video.src = ''
      // 保存startTime到data，供后续使用
      this.pendingStartTime = startTime
      if (Hls.isSupported()) {
        const hls = new Hls({
          debug: false,
          enableWorker: true,
          lowLatencyMode: true,
          backBufferLength: 90
        })
        this.hlsInstance = hls
        hls.loadSource(videoUrl)
        hls.attachMedia(video)

        // 关键：在MANIFEST_PARSED时先暂停，设置currentTime后再播放
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          // 如果有起始时间，检查seekable范围
          if (this.pendingStartTime > 0) {
            const seekableEnd = video.seekable.length > 0 ? video.seekable.end(0) : 0
            const seekableStart = video.seekable.length > 0 ? video.seekable.start(0) : 0

            // 如果seekable已经有数据
            if (seekableEnd > 0) {
              if (this.pendingStartTime >= seekableStart && this.pendingStartTime <= seekableEnd) {
                // 目标时间在范围内，正常seek
                video.currentTime = this.pendingStartTime
              } else {
                // 目标时间超出范围，从0开始
                video.currentTime = 0
              }
              this.pendingStartTime = 0
            }
            // 否则等canplay事件再处理
          }

          video.play().catch(() => {})
        })

        // 关键：在视频可以播放时再检查一次（MANIFEST_PARSED时seekable可能还没准备好）
        const seekHandler = () => {
          const targetTime = this.pendingStartTime
          if (targetTime > 0 && video.seekable.length > 0) {
            const seekableEnd = video.seekable.end(0)
            const seekableStart = video.seekable.start(0)

            if (targetTime >= seekableStart && targetTime <= seekableEnd) {
              // 目标时间在范围内，正常seek
              video.currentTime = targetTime
            } else {
              // 目标时间超出范围，从0开始
              video.currentTime = 0
            }
            this.pendingStartTime = 0
          }
          video.removeEventListener('canplay', seekHandler)
          video.removeEventListener('loadedmetadata', seekHandler)
        }
        video.addEventListener('canplay', seekHandler)
        video.addEventListener('loadedmetadata', seekHandler)
        hls.on(Hls.Events.ERROR, (event, data) => {
          console.error('HLS 错误:', event, data)
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                console.log('网络错误，尝试恢复...')
                hls.startLoad()
                break
              case Hls.ErrorTypes.MEDIA_ERROR:
                console.log('媒体错误，尝试恢复...')
                hls.recoverMediaError()
                break
              default:
                console.log('无法恢复的错误，销毁实例')
                hls.destroy()
                this.hlsInstance = null
                break
            }
          }
        })

      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        console.log('使用原生 HLS 播放')
        video.src = videoUrl
        video.addEventListener('loadedmetadata', () => {
          if (this.pendingStartTime > 0) {
            video.currentTime = this.pendingStartTime
            this.pendingStartTime = 0
          }
          video.play().catch((err) => {
            console.log('自动播放被阻止:', err)
          })
        })
      } else {
        console.error('浏览器不支持 HLS 播放')
      }
    },
    async playActiveVideo() {
      const video = this.$refs.mainVideo
      if (!video) return
      const videoUrl = this.getBannerVal(this.activeBanner,'anchor_video')
      if (!videoUrl) {
        console.log('当前没有视频')
        return
      }
      // anchorid作为pos参数，id作为vid参数
      const anchorid = this.getBannerVal(this.activeBanner,'anchorid')
      // 获取当前视频的唯一标识，用于localStorage的key
      const videoId = this.getBannerVal(this.activeBanner, 'id')

      console.log('videoId', videoId, 'anchorid', anchorid, 'videoUrl', videoUrl)
      this.currentVideoId = videoId
      // 从后端API获取进度
      let startTime = await this.getVideoProgress(videoId, anchorid)
      console.log('最终从', startTime, '秒开始播放')
      this.initHls(video, videoUrl, startTime)
    },
    AXIOS_getdata(){
      // 获取title参数：activeNav=-1为首页（空），>=0时取对应分类名
      let titleParam = '';
      if (this.activeNav >= 0) {
        titleParam = this.navItems[this.activeNav];
      }
      this.hasTitleParam = !!titleParam;

      axios.get('https://guangxing.xiangyouhulian.cn/api/index/getData',{params:{title:titleParam}})
        .then(response => {
          console.log('获取数据成功:', response.data.data);
          this.bannerList = response.data.data.one || [];
          this.featuredList = response.data.data.two || [];
          this.categoryList = response.data.data.three || [];
          this.$nextTick(() => {
            setTimeout(() => {
              this.playActiveVideo()
            }, 300)
          })
        })
        .catch(error => {
          console.error('获取轮播图数据失败:', error)
        })
    },

  },
  beforeDestroy() {
    // 组件销毁前：移除事件监听、保存进度、销毁HLS实例
    // 移除页面刷新/关闭的事件监听，防止内存泄漏
    if (this._beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this._beforeUnloadHandler)
    }
    // 最后一次保存视频进度到后端
    this.saveCurrentVideoProgress()
    // 销毁HLS播放器实例，释放资源
    this.destroyHls()
  }
}
</script>

<style scoped lang="scss">
/* ========== 布局：左侧垂直导航 + 全宽 Banner + 横向缩略图条 ========== */
.home_page {
  width: 100%;
  background-color: #ffffff;
}

/* 主内容区 */
.main_content {
  padding: 24px 32px 40px;
  width: 70%;
  margin: 0 auto;
  position: relative;
}

/* ===== Hero 区 ===== */
.hero_section {
  position: relative;
  margin-bottom: 40px;
}
/* Hero 区背景图：左右两侧 */
.hero_bg {
  width: 100%;
  height: 105%;
  position: absolute;
  top: 0;
  left: 0;
}
.hero_bg_img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
/* 图1布局容器：左主视频 + 右竖栏 */
.hero_inner {
  position: relative;
  z-index: 1;
  width: 70%;
  margin: 0 auto;
  display: flex;
  align-items: stretch;
  gap: 12px;
  padding-top: 30px;
}
.hero_main {
  position: relative;
  flex: 1;
  min-width: 0;
  aspect-ratio: 16 / 9;
  border-radius: 0;
  overflow: hidden;
  background: #000;
  border-radius: 15px;
}
.banner_bg_blur {
  position: absolute;
  top: -30px; left: -30px; right: -30px; bottom: -30px;
  background-size: cover;
  background-position: center;
  filter: blur(30px);
  z-index: 0;
}
.banner_img {
  position: relative;
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  z-index: 3;
  video { width: 100%; height: 100%; }
}
.banner_overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.18) 45%, transparent 75%);
  z-index: 3;
}
.banner_info {
  position: absolute; left: 32px; bottom: 32px;
  color: #fff; z-index: 3; max-width: 60%;
}
.live_tag {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 3px 10px;
  background: #fb7299; border-radius: 12px;
  font-size: 12px; margin-bottom: 14px;
  color: #fff; font-weight: 500;
  &::before {
    content: ''; display: inline-block;
    width: 6px; height: 6px;
    background: #fff; border-radius: 50%;
  }
}
.banner_title {
  max-width: 600px; font-size: 28px; font-weight: 700;
  margin-bottom: 10px; line-height: 1.3;
  text-shadow: 0 2px 6px rgba(0,0,0,0.4);
}
.anchor_info { display: flex; align-items: center; margin-bottom: 12px; }
.anchor_avatar {
  width: 32px; height: 32px; border-radius: 50%;
  margin-right: 10px; border: 2px solid #fff;
}
.anchor_name { font-size: 14px; font-weight: 500; }
.stats { display: flex; gap: 18px; }
.stat_item {
  font-size: 13px; color: #f5f5f5; opacity: 0.95;
  display: flex; align-items: center;
  img { width: 14px; height: 14px; margin-right: 5px; }
}
.enter_btn {
  position: absolute; right: 32px; bottom: 32px;
  padding: 12px 28px;
  background: #fb7299; border: none; border-radius: 24px;
  color: #fff; font-size: 14px; font-weight: 500;
  cursor: pointer; z-index: 3;
  transition: background 0.2s ease;
  &:hover { background: #ff5c8a; }
}

/* ===== 右侧竖向推荐栏（图1 B站直播风格） ===== */
.hero_rail {
  flex-shrink: 0;
  width: 240px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 12px;
  overflow-y: auto;
  overscroll-behavior: contain;
  &::-webkit-scrollbar { width: 6px; }
  &::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.18); border-radius: 3px; }
  &::-webkit-scrollbar-track { background: transparent; }
}
.rail_card {
  position: relative;
  flex-shrink: 0;
  aspect-ratio: 16 / 10;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  background: #000;
  border: 2px solid transparent;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
  &:hover { border-color: rgba(251, 114, 153, 0.55); }
  &.active { border-color: #fb7299; }
  /* 选中项左侧的粉色三角标记 */
  &.active::after {
    content: '';
    position: absolute;
    left: 0; top: 50%;
    transform: translateY(-50%);
    border: 5px solid transparent;
    border-left: 6px solid #fb7299;
  }
}
.rail_img {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  object-fit: contain;
}
.rail_mask {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.12) 45%, transparent 70%);
}
.rail_text {
  position: absolute;
  left: 8px; right: 8px; bottom: 6px;
}
.rail_card_title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rail_card_name {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 1.3;
  color: rgba(255,255,255,0.72);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== 分区通用 ===== */
.section { margin-bottom: 40px; }
.section_header {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 18px;
}
.section_title {
  font-size: 18px; font-weight: 700; color: #1a1a1a;
  margin: 0; padding-left: 14px; position: relative; line-height: 1.2;
  &::before {
    content: ''; position: absolute; left: 0; top: 50%;
    transform: translateY(-50%);
    width: 4px; height: 18px;
    background: #fb7299; border-radius: 2px;
  }
}
.section_more {
  font-size: 12px; color: #9499a0; cursor: pointer;
  transition: color 0.2s ease;
  &:hover { color: #fb7299; }
}

/* ===== 正在直播：图2风格卡片 ===== */
.featured_grid,
.featured_grid_horizontal {
  display: grid;
  /* 自动填充：窄屏最少4列，屏幕越宽列数自动增加，所有列宽永远相等 */
  grid-template-columns: repeat(5, minmax(230px, 1fr));
  gap: 14px;
}
.featured_card,
.featured_card_horizontal {
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  /* 关键：允许收缩到列宽，防止 nowrap 文字把列撑宽 */
  min-width: 0;
}
.card_image_wrap,
.card_image_wrap_horizontal {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  background: #f0f0f2;
  transition: border-radius 0.2s ease;
  flex-shrink: 0;
}
/* 分类页（音乐/乐器/舞蹈/颜值/生活方式）：竖向图片区，高>宽，3:4 比例 */
.card_image_wrap {
  aspect-ratio: 3 / 4;
}
/* 首页：横向图片区 */
.card_image_wrap_horizontal {
  height: 170px;
}
.featured_card:hover .card_image_wrap,
.featured_card_horizontal:hover .card_image_wrap_horizontal {
  border-radius: 0;
}
.card_image,
.card_image_horizontal {
  width: 100%; height: 100%;
  object-fit: cover;
  /* 顶部对齐：竖版封面优先显示人物头部，避免裁到脸 */
  object-position: center top;
}

/* 遮罩层 */
.card_overlay,
.card_overlay_horizontal {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 50%);
}
.card_overlay_offline {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 55%, rgba(0,0,0,0.2) 100%);
}
.offline_center_text {
  position: absolute; top: 40%; left: 50%;
  transform: translate(-50%, -50%);
  text-align: center; z-index: 2;
  .offline_status {
    font-size: 14px; font-weight: 600; color: #fff;
    padding: 6px 18px; background: rgba(0, 0, 0, 0.6); border-radius: 6px;
  }
  .offline_time {
    display: inline-block;
    font-size: 11px; color: rgba(255, 255, 255, 0.9);
    margin-top: 8px; padding: 3px 10px;
    background: rgba(0, 0, 0, 0.45); border-radius: 4px;
  }
}

/* 左上角直播标签 */
.live_badge,
.live_badge_horizontal {
  position: absolute; top: 8px; left: 8px;
  display: flex; align-items: center;
  border-radius: 3px; overflow: hidden;
  font-size: 11px; color: #fff; z-index: 2;
}
.live_badge_text {
  display: flex; align-items: center;
  padding: 2px 7px; background: #fb7299; font-weight: 500;
}
.live_badge_text_live {
  display: flex; align-items: center;
  padding: 2px 7px; background: #9499a0; font-weight: 500; border-radius: 3px;
}
.live_badge_text_offline {
  display: flex; align-items: center;
  padding: 2px 7px; background: #f5a623; font-weight: 500;
}
.live_badge_count {
  display: flex; align-items: center; gap: 3px;
  padding: 2px 5px; background: rgba(0, 0, 0, 0.55); color: #e6e6e6;
  img { width: 11px; height: 11px; margin-top: 1px; }
}

/* 卡片介绍文字 */
.card_desc {
  font-size: 13px;
  color: #1a1a1a;
  line-height: 1.4;
  padding: 8px 6px 2px;
  /* border-box 下 padding 算在 height 内，总高度固定 */
  height: 42px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
  flex-shrink: 0;
}

/* 图片下方信息行（图2风格：头像+主播名 | 👁人数） */
.card_info_row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 4px 6px 8px;
  gap: 8px;
  /* border-box 下 padding 算在 height 内，总高度固定 */
  height: 56px;
  box-sizing: border-box;
  flex-shrink: 0;
}
.card_info_left {
  display: flex; align-items: center; gap: 8px;
  flex: 1; min-width: 0;
}
.card_avatar_sm {
  width: 32px; height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid #f0f0f2;
}
.card_name_sm {
  font-size: 13px;
  color: #61666d;
  font-weight: 500;
  overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
  transition: color 0.2s ease;
}
.featured_card:hover .card_name_sm,
.featured_card_horizontal:hover .card_name_sm {
  color: #fb7299;
}
.card_info_right {
  display: flex; align-items: center; gap: 3px;
  flex-shrink: 0;
}
.card_view_icon {
  width: 14px; height: 14px;
  opacity: 0.6;
}
.card_view_num {
  font-size: 12px;
  color: #9499a0;
}

/* 卡片主体：图片下方的定位容器 */
.card_body {
  position: relative;
}

/* ===== 正在直播：图2风格卡片 ===== */
.featured_grid,
.featured_grid_horizontal {
  display: grid;
  grid-template-columns: repeat(5, minmax(230px, 1fr));
  gap: 14px;
}
.featured_card,
.featured_card_horizontal {
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
}
.card_image_wrap,
.card_image_wrap_horizontal {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  background: #f0f0f2;
  transition: border-radius 0.2s ease;
  flex-shrink: 0;
}
.card_image_wrap {
  height: 400px;
}
.card_image_wrap_horizontal {
  height: 400px;
}
.featured_card:hover .card_image_wrap,
.featured_card_horizontal:hover .card_image_wrap_horizontal {
  border-radius: 0;
}
.card_image,
.card_image_horizontal {
  width: 100%; height: 100%;
  object-fit: cover;
  object-position: center top;
  transition: transform 0.2s ease;
}
.featured_card:hover .card_image,
.featured_card_horizontal:hover .card_image_horizontal {
}

.card_overlay,
.card_overlay_horizontal {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 50%);
}
.card_overlay_offline {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 55%, rgba(0,0,0,0.2) 100%);
}
.offline_center_text {
  position: absolute; top: 40%; left: 50%;
  transform: translate(-50%, -50%);
  text-align: center; z-index: 2;
  .offline_status {
    font-size: 14px; font-weight: 600; color: #fff;
    padding: 6px 18px; background: rgba(0, 0, 0, 0.6); border-radius: 6px;
  }
  .offline_time {
    display: inline-block;
    font-size: 11px; color: rgba(255, 255, 255, 0.9);
    margin-top: 8px; padding: 3px 10px;
    background: rgba(0, 0, 0, 0.45); border-radius: 4px;
  }
}

.live_badge,
.live_badge_horizontal {
  position: absolute; top: 8px; left: 8px;
  display: flex; align-items: center;
  border-radius: 3px; overflow: hidden;
  font-size: 11px; color: #fff; z-index: 2;
}
.live_badge_text {
  display: flex; align-items: center;
  padding: 2px 7px; background: #fb7299; font-weight: 500;
}
.live_badge_text_live {
  display: flex; align-items: center;
  padding: 2px 7px; background: #9499a0; font-weight: 500; border-radius: 3px;
}
.live_badge_text_offline {
  display: flex; align-items: center;
  padding: 2px 7px; background: #f5a623; font-weight: 500;
}
.live_badge_count {
  display: flex; align-items: center; gap: 3px;
  padding: 2px 5px; background: rgba(0, 0, 0, 0.55); color: #e6e6e6;
  img { width: 11px; height: 11px; margin-top: 1px; }
}

.card_desc {
  font-size: 13px;
  color: #1a1a1a;
  line-height: 1.4;
  padding: 8px 6px 2px;
  height: 42px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
  flex-shrink: 0;
}

.card_info_row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 4px 6px 8px;
  gap: 8px;
  height: 56px;
  box-sizing: border-box;
  flex-shrink: 0;
}
.card_info_left {
  display: flex; align-items: center; gap: 8px;
  flex: 1; min-width: 0;
}
.card_avatar_sm {
  width: 32px; height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid #f0f0f2;
}
.card_name_sm {
  font-size: 13px;
  color: #61666d;
  font-weight: 500;
  overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
  transition: color 0.2s ease;
}
.featured_card:hover .card_name_sm,
.featured_card_horizontal:hover .card_name_sm {
  color: #fb7299;
}
.card_info_right {
  display: flex; align-items: center; gap: 3px;
  flex-shrink: 0;
}
.card_view_icon {
  width: 14px; height: 14px;
  opacity: 0.6;
}
.card_view_num {
  font-size: 12px;
  color: #9499a0;
}

.card_body {
  position: relative;
}

.card_hover_preview {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 280px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transition: all 0.18s ease;
  z-index: 999;
  pointer-events: none;
}
.featured_card:hover .card_hover_preview,
.featured_card_horizontal:hover .card_hover_preview {
  opacity: 1;
  visibility: visible;
  top: 10px;
  pointer-events: auto;
}
.preview_image {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #f0f0f2;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.preview_overlay {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 60%);
}
.preview_live_tag {
  position: absolute; top: 8px; left: 8px;
  padding: 2px 8px;
  background: #fb7299; color: #fff;
  font-size: 11px; font-weight: 500; border-radius: 3px;
}
.preview_info {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 12px;
}
.preview_avatar {
  width: 36px; height: 36px; border-radius: 50%;
  flex-shrink: 0;
}
.preview_text {
  flex: 1; min-width: 0;
  display: flex; flex-direction: column; gap: 2px;
}
.preview_name {
  font-size: 13px; font-weight: 600; color: #1a1a1a;
  overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
}
.preview_desc {
  font-size: 11px; color: #9499a0;
  overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
}
.preview_follow_btn {
  padding: 4px 14px;
  background: #fb7299; color: #fff;
  border: none; border-radius: 14px;
  font-size: 12px; font-weight: 500;
  cursor: pointer; flex-shrink: 0;
  transition: background 0.2s ease;
  &:hover { background: #ff5c8a; }
}

/* ===== 星动活动：单张大长图广告 ===== */
.activity_grid {
  border-radius: 8px; overflow: hidden;
  cursor: pointer;
  cursor: pointer;
}
.activity_image {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
}

/* ===== 直播回放 ===== */
.category_grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 16px;
}
.category_card {
  position: relative; border-radius: 8px; overflow: hidden;
  cursor: pointer;
}
.category_image { width: 100%; height: 100%; object-fit: cover; }
.category_overlay {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 55%);
}
.category_live_badge {
  position: absolute; top: 10px; left: 10px;
  display: flex; align-items: center;
  border-radius: 4px; overflow: hidden;
  font-size: 11px; color: #fff;
}
.category_live_text {
  display: flex; align-items: center;
  padding: 3px 8px; background: #9499a0; font-weight: 500; border-radius: 4px;
}
.category_anchor {
  position: absolute; bottom: 12px; left: 12px;
  display: flex; align-items: center; gap: 8px;
}
.category_avatar {
  width: 30px; height: 30px; border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.8);
}
.category_name {
  font-size: 14px; color: #fff; font-weight: 500;
  text-shadow: 0 1px 3px rgba(0,0,0,0.5);
}

/* 响应式 */
@media (max-width: 1200px) {
  /* 窄屏保证最少4列（卡片变窄），minmax(0,1fr) 保证列宽不受文字内容影响 */
  .featured_grid, .featured_grid_horizontal {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .category_grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .hero_rail { width: 200px; }
}
@media (max-width: 900px) {
  .main_content { padding: 16px 18px 28px; }
  .banner_title { font-size: 22px; }
  .featured_grid, .featured_grid_horizontal {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  /* 窄屏：主视频在上，推荐栏变为底部横向滚动条 */
  .hero_inner { flex-direction: column; }
  .hero_rail {
    width: 100%;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .rail_card { width: 200px; flex-shrink: 0; }
}
</style>
